<script setup>

import QuestionComponent from '@/components/DefaultVr/Components/QuestionComponent.vue'
import TranslationProvider from '@/provider/translations.js'

defineProps(['handleAnswer', 'compiledPoll', 'questionGroup'])
</script>

<template>
  <div>
    <h3>Domande</h3>
    <p class="form-text">
      {{TranslationProvider.getTrans('app.required_questions_message')}}
    </p>

    <div v-for="(question, index) in questionGroup['questions']" :key="question.id">
      <question-component :last="index === questionGroup['questions'].length - 1"
                          :compiled-poll="compiledPoll"
                          :handle-answer="handleAnswer"
                          :question="question"
      >
      </question-component>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
